import React, { Component } from "react";
import "../../Styles/TenanatDashBoard.scss";
import BarChartContainer from "./BarChart";
import BurnDownChartContainer from "./BurnDownChart";
import HeatMapChartContainer from "./HeatMapChart";
import HeatMapTimeStamp from "./HeatMapTimeStamp";
import LineChartContainer from "./LineChart";
import PieChartContainer from "./PieChart";
import Histogramwidget from "./HistogramWidget";
import Images from "../../Assets/Images";
import RichTextChart from "./RichTextChart";
import TileChart from "./TileChart";
import DataReportForRisk from "./DataReportForRisk";
import DataReportForAction from "./DataReportForAction";
import TrendingLineChart from "./TrendingLineChart";
import DataReportForTasks from "../Tasks/DataReportForTasks";
import DataReportForActivities from "../Tasks/DataReportForActivities";
import TaskKPITileChart from "../TaskKPITileChart";

const getBaseItemStyle = (isActive) => ({
  fontSize: "16px",
  textAlign: "center",
  outline: "none",
  cursor: "move",
  display: "inline-block",
});
const classNames = ["col-xs-12 col-sm-12 col-md-6"];
export default class SortableWidgetUiHome extends Component {
  constructor(props) {
    super(props);
    this.state = { expandWidgetId: [] };
    if (this.props.isDisabled) {
      classNames.push("k-state-disabled");
    }
  }

  changeLineChartWidth = (widgetId) => {
    // this.props.onSetWidgetId(widgetId);

    let widgetValue = this.state.expandWidgetId.indexOf(widgetId);
    if (widgetValue !== -1) {
      this.state.expandWidgetId.splice(widgetValue, 1);
      this.setState({ expandWidgetId: this.state.expandWidgetId });
    } else {
      let value = this.state.expandWidgetId;
      value.push(widgetId);
      this.setState({ expandWidgetId: value });
    }
  };

  handleWidgetFullView = (widget) => {
    let widgetView =
      this.state.expandWidgetId &&
      this.state.expandWidgetId.filter((item) => item === widget);
    if (widgetView.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  getChartContainer = (chart) => {
    var componant = "";
    if (chart.widgetType == "LINE_CHART") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <LineChartContainer
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    } else if (chart.widgetType == "BAR_CHART") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <BarChartContainer
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    } else if (chart.widgetType == "TEXT_WIDGET") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>

          <RichTextChart
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            refreshTextWidget={this.refreshTextWidget}
            flag={false}
            expandIcon={true}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    } else if (chart.widgetType == "KPI" && chart.reportType != "Task") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <TileChart
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            refreshTextWidget={this.refreshTextWidget}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    }
    else if (chart.widgetType == "KPI" && chart.reportType === "Task") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <TaskKPITileChart
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            refreshTextWidget={this.refreshTextWidget}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    } else if (chart.widgetType == "BURN_DOWN_CHART") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <BurnDownChartContainer
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    } else if (chart.widgetType == "PIE_CHART") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <PieChartContainer
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    } else if (chart.widgetType == "DOUGHNUT_CHART") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <Histogramwidget
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    } else if (chart.widgetType == "HEAT_MAP") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          {chart.widgetType == "HEAT_MAP" && chart.timeStamp == false ? (
            <HeatMapChartContainer
              chartInputs={chart}
              changeLineChartWidth={this.changeLineChartWidth}
              flag={false}
              expandIcon={true}
              viewDataSetIcon={true}
              refreshTextNarative={this.refreshTextNarative}
            />
          ) : (
            <HeatMapTimeStamp
              chartInputs={chart}
              changeLineChartWidth={this.changeLineChartWidth}
              flag={false}
              expandIcon={true}
              viewDataSetIcon={true}
              refreshTextNarative={this.refreshTextNarative}
            />
          )}
        </div>
      );
    }else if (chart.widgetType == "DATA"&& chart.isActionWidget && chart.reportType === "Action") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <DataReportForAction
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            customFieldsmaster={this.props.customFieldsmaster}
                    probabilityRangeMaster={this.props.probabilityRangeMaster}
                    refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    }else if (chart.widgetType == "DATA"&& !chart.isActionWidget && chart.reportType === "Risk") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <DataReportForRisk
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            customFieldsmaster={this.props.customFieldsmaster}
            HeatMapConfigDataOpportunity={this.props.HeatMapConfigDataOpportunity}
                  HeatMapConfigDataThreat={this.props.HeatMapConfigDataThreat}
                  dynamicHeatmapProbabilityRange={this.props.dynamicHeatmapProbabilityRange}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    }else if (chart.widgetType == "DATA"&&  chart.reportType === "Task") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <DataReportForTasks
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            customFieldsmaster={this.props.customFieldsmaster}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    }else if (chart.widgetType == "DATA" && chart.reportType === "TaskAction") {
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <DataReportForActivities
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            customFieldsmaster={this.props.customFieldsmaster}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    }else if(chart.widgetType == "TRENDING_CHART"){
      componant = (
        <div>
          <ul className="WidgetActions">
            <li
              title="Remove from home"
              onClick={() => this.props.removeFromHome(chart)}
            >
              <a>
                <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
              </a>
            </li>
          </ul>
          <TrendingLineChart
            chartInputs={chart}
            changeLineChartWidth={this.changeLineChartWidth}
            flag={false}
            expandIcon={true}
            viewDataSetIcon={true}
            refreshTextNarative={this.refreshTextNarative}
          />
        </div>
      );
    }
    return componant;
  };
  refreshTextNarative=(text,widgetId)=>{
    this.props.refreshTextNarative(text,widgetId);
  }
  render() {
    const { isDisabled, isActive, style, attributes, dataItem, forwardRef } =
      this.props;
    const fullview = this.handleWidgetFullView(dataItem.widgetId);

    return (
      <div
        ref={forwardRef}
        {...attributes}
        style={{
          ...getBaseItemStyle(isActive),
          ...style,
        }}
        // className={classNames.join(' ')}
        className={fullview ? "fullWidth wBox" : "wBox"}
      >
        <div className="wGrid">
          <div className="wGBox">
            <div className="wgHeader">
              <h4
                title={
                  dataItem.description
                    ? dataItem.description
                    : "Description not available"
                }
              >
                {dataItem.widgetName}
              </h4>
            </div>

            <div className="chartCont">{this.getChartContainer(dataItem)}</div>
          </div>
        </div>
      </div>
    );
  }
}
